import React, { useEffect, useState } from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar'
import { useLocation } from 'react-router-dom';

export default function Home() {
  const [history, setHistory] = useState([]);
  const [prices, setPrices] = useState({});

  useEffect(() => {
    const storedHistory = JSON.parse(localStorage.getItem('history'));
    const storedPrices = JSON.parse(localStorage.getItem('prices'));

    if (storedHistory && storedPrices) {
      setHistory(storedHistory);
      setPrices(storedPrices);
    }
  }, []);

  return (
    <div>
      <>
      <Header/>
      <Sidebar/>
  <div className="page-wrapper bg-wrapper">
    <div className="content">
      <div className="row">
        <div className="col-sm-12">
          <div className="welcome-header">
            <div className="row">
              <div className="col-xl-6 col-lg-5 col-md-5 d-flex align-items-center">
                <div className="wel-come-name">
                  <h4>
                    Welcome , <span>Admin</span>
                  </h4>
                </div>
              </div>
              <div className="col-xl-6 col-lg-7 col-md-7">
                <div className="welcome-wallet">
                  <div className="wallet-list">
                    <span>Wallet : 56, 444658</span>
                  </div>
                  <div className="bookingrange btn-book ms-2 me-2">
                    <img src="/assets/img/icon/calendar-icon.svg" alt="" />
                    <span />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="dash-widget-blk">
            <ul>
              <li>
                <div className="premium-box box-blue">
                  <img src="/assets/img/icon/dash-icon-02.svg" alt="" />
                </div>
                <div className="premium-name-blk title-blue">
                  <h4>Ethereum</h4>
                  <h3>$ {prices.ETH}</h3>
                </div>
                <div className="premium-img">
                  <img src="/assets/img/wave-01.png" alt="" />
                </div>
              </li>
              <li>
                <div className="premium-box box-pink">
                  <img width="50" src="https://cdn3d.iconscout.com/3d/premium/thumb/binance-crypto-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--symbol-sign-logo-coin-glossy-pack-science-technology-illustrations-3591027.png?f=webp" alt="" />
                </div>
                <div className="premium-name-blk title-pink">
                  <h4>Binance</h4>
                  <h3>$ {prices.BNB}</h3>
                </div>
                <div className="premium-img">
                  <img src="/assets/img/wave-02.png" alt="" />
                </div>
              </li>
              <li>
                <div className="premium-box box-green">
                  <img width="50" src="https://cdn3d.iconscout.com/3d/premium/thumb/tron-trx-badge-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--cryptocurrency-symbol-crypto-badges-vol-1-pack-science-technology-illustrations-4414723.png?f=webp" alt="" />
                </div>
                <div className="premium-name-blk title-green">
                  <h4>Tron </h4>
                  <h3>$ {prices.TRX}</h3>
                </div>
                <div className="premium-img">
                  <img src="/assets/img/wave-03.png" alt="" />
                </div>
              </li>
              <li>
                <div className="premium-box box-orange">
                  <img width="50" src="https://cdn-icons-png.flaticon.com/512/6001/6001527.png" alt="" />
                </div>
                <div className="premium-name-blk title-orange">
                  <h4>Solana</h4>
                  <h3>$ {prices.SOL}</h3>
                </div>
                <div className="premium-img">
                  <img src="/assets/img/wave-04.png" alt="" />
                </div>
              </li>
              <li>
                <div className="premium-box box-light">
                  <img width="50" src="https://cryptologos.cc/logos/polygon-matic-logo.png" alt="" />
                </div>
                <div className="premium-name-blk title-light">
                  <h4>Polygon </h4>
                  <h3>$ {prices.MATIC}</h3>
                </div>
                <div className="premium-img">
                  <img src="/assets/img/wave-05.png" alt="" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-xl-12 mb-3">
          <ul className="bit-coin-blk">
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p>
                <i className="fas fa-arrow-up me-1" />
                (2.38%){" "}
              </p>
            </li>
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p className="low-range">
                <i className="fas fa-arrow-down me-1" />
                (2.38%){" "}
              </p>
            </li>
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p>
                <i className="fas fa-arrow-up me-1" />
                (2.38%){" "}
              </p>
            </li>
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p>
                <i className="fas fa-arrow-up me-1" />
                (2.38%){" "}
              </p>
            </li>
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p>
                <i className="fas fa-arrow-up me-1" />
                (2.38%){" "}
              </p>
            </li>
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p>
                <i className="fas fa-arrow-up me-1" />
                (2.38%){" "}
              </p>
            </li>
            <li>
              <h4>BITCOIN (BTC)</h4>
              <h3>$3,245</h3>
              <p>
                <i className="fas fa-arrow-up me-1" />
                (2.38%){" "}
              </p>
            </li>
          </ul>
        </div>
      </div> */}
    
   
    
      <div className="row">
        <div className="col-md-12">
          <div className="buy-form mb-0">
            <div className="border-watch">
              <div className="row">
                <div className="col d-flex align-items-center">
                  <div className="watch-head">
                    <h4>Users</h4>
                  </div>
                </div>
                <div className="col-auto d-flex">
                  <div className="bookingrange btn-book me-2">
                    <span />
                  </div>
                  <div className="down-range">
                    <a href="javascript:;">
                      <img src="/assets/img/icon/down-icon.svg" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="datatable table custom-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th style={{ minWidth: 110 }}>User Id</th>
                    <th style={{ minWidth: 110 }}>App Id</th>
                    <th style={{ minWidth: 110 }}>Joining Date</th>
                    <th style={{ minWidth: 110 }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {history && history.length > 0 ? (
                    history.map((data, index) => (
                      <tr key={index + 1}>
                        <td>{index + 1}</td>
                        <td>
                          <img
                            src="/assets/img/icon/watch-icon-07.svg"
                            alt="Award"
                            className="me-2"
                          />
                          User {data.user_id}
                        </td>
                        <td>{data.app_id}</td>
                        <td>{data.created_at}</td>
                        <td style={{ color: 'green' }}>Active</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="notification-box">
    <div className="msg-sidebar notifications msg-noti">
      <div className="topnav-dropdown-header">
        <span>Messages</span>
      </div>
      <div className="drop-scroll msg-list-scroll" id="msg_list">
        <ul className="list-box">
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">R</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Richard Miles </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item new-message">
                <div className="list-left">
                  <span className="avatar">J</span>
                </div>
                <div className="list-body">
                  <span className="message-author">John Doe</span>
                  <span className="message-time">1 Aug</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">T</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Tarah Shropshire </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">M</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Mike Litorus</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">C</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Catherine Manseau </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">D</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Domenic Houston </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">B</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Buster Wigton </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">R</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Rolland Webber </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">C</span>
                </div>
                <div className="list-body">
                  <span className="message-author"> Claire Mapes </span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">M</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Melita Faucher</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">J</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Jeffery Lalor</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">L</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Loren Gatlin</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="chat.html">
              <div className="list-item">
                <div className="list-left">
                  <span className="avatar">T</span>
                </div>
                <div className="list-body">
                  <span className="message-author">Tarah Shropshire</span>
                  <span className="message-time">12:28 AM</span>
                  <div className="clearfix" />
                  <span className="message-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                  </span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div className="topnav-dropdown-footer">
        <a href="chat.html">See all messages</a>
      </div>
    </div>
  </div>
</>

    </div>
  )
}
